import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useInfiniteHits, useInstantSearch } from 'react-instantsearch';
import useScreen from 'hooks/useScreen';
import { getBlogPath } from 'components/consumer/consumer-search/commons/helpers';
const ResultsHeader = t0 => {
  const $ = _c(7);
  const {
    variant: t1,
    children
  } = t0;
  const variant = t1 === undefined ? "desktop" : t1;
  const t2 = variant === "advanced-search";
  const t3 = variant !== "mobile";
  const t4 = variant === "mobile";
  let t5;
  if ($[0] !== t2 || $[1] !== t3 || $[2] !== t4) {
    t5 = classNames("mx-0 my-2.5 text-base font-bold", {
      "hidden lg:block": t2,
      "text-gray": t3,
      "text-brand block mt-[15px] mb-[7px]": t4
    });
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== children || $[5] !== t5) {
    t6 = <div className={t5}>{children}</div>;
    $[4] = children;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};
ResultsHeader.propTypes = {
  variant: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string])
};
const StaticPages = t0 => {
  const $ = _c(23);
  const {
    onPageClick,
    variant: t1,
    forComponent,
    query: t2,
    currentPage: t3
  } = t0;
  const variant = t1 === undefined ? "desktop" : t1;
  const query = t2 === undefined ? "" : t2;
  const currentPage = t3 === undefined ? "" : t3;
  const {
    items: hits,
    showMore,
    isLastPage
  } = useInfiniteHits();
  const {
    status
  } = useInstantSearch();
  const {
    windowWidth
  } = useScreen();
  const infiniteScrollThreshold = windowWidth <= 768 ? "2800px" : "2200px";
  let t4;
  if ($[0] !== currentPage || $[1] !== hits || $[2] !== onPageClick || $[3] !== query) {
    let t5;
    if ($[5] !== currentPage || $[6] !== onPageClick || $[7] !== query) {
      t5 = hit => {
        if (!hit?.url) {
          return null;
        }
        const isStoriesUrl = hit.url && hit.url.startsWith("/stories");
        const handleClick = () => {
          if (onPageClick) {
            onPageClick({
              url: hit.url,
              query,
              currentPage,
              isStoriesUrl
            });
          }
        };
        const finalURL = isStoriesUrl ? <Link onClick={handleClick} to={getBlogPath(hit.url)}>{getBlogPath(hit.url)}</Link> : <Link onClick={handleClick} to={(hit.url || "").startsWith("/") ? hit.url : `/${hit.url}`}>{hit.url}</Link>;
        return <div key={hit.objectID || hit.url} className="flex flex-col bg-gray-light8 p-8 mb-8 text-gray"><div className="text-[1.2rem] leading-[2rem] no-underline tracking-[-.02em] mt-0 mx-0 mb-[1.1rem] font-normal text-gray">{hit.title || hit.name}</div><div className="font-normal text-gray text-base leading-[1.5rem] flex flex-col items-start text-[.8rem]">{hit.meta_description || hit.description}</div><div className="no-underline text-[.8rem] cursor-pointer [&_a]:text-brand">{finalURL}</div></div>;
      };
      $[5] = currentPage;
      $[6] = onPageClick;
      $[7] = query;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t4 = hits.map(t5).filter(Boolean);
    $[0] = currentPage;
    $[1] = hits;
    $[2] = onPageClick;
    $[3] = query;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const pagesList = t4;
  const headerText = forComponent === "mobile" ? "Results" : "Pages";
  if (!hits || hits.length === 0) {
    if (status === "idle") {
      let t5;
      if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = <div role="status" aria-live="polite" className="py-8 text-center">No results found.</div>;
        $[9] = t5;
      } else {
        t5 = $[9];
      }
      return t5;
    }
    let t5;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="w-full flex items-center justify-center min-h-[20vh]"><div className="text-center"><div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mb-2" role="status" aria-label="Loading" /></div></div>;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  let t5;
  if ($[11] !== headerText || $[12] !== variant) {
    t5 = <ResultsHeader variant={variant}>{headerText}</ResultsHeader>;
    $[11] = headerText;
    $[12] = variant;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const t6 = !isLastPage;
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <h4>Loading...</h4>;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== infiniteScrollThreshold || $[16] !== pagesList || $[17] !== showMore || $[18] !== t6) {
    t8 = <InfiniteScroll dataLength={pagesList.length} next={showMore} hasMore={t6} scrollThreshold={infiniteScrollThreshold} loader={t7}>{pagesList}</InfiniteScroll>;
    $[15] = infiniteScrollThreshold;
    $[16] = pagesList;
    $[17] = showMore;
    $[18] = t6;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t5 || $[21] !== t8) {
    t9 = <div className="w-full">{t5}{t8}</div>;
    $[20] = t5;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  return t9;
};
export default StaticPages;